define('webshopFiltersListView',[
  'module',
  'marionette',
  'underscore',
  'entities/webshop/filters',
  'template!webshopFiltersListView'
], function (
  Module,
  Marionette,
  _,
  FiltersApi,
  Tpl
) {
  'use strict';

  // Left pane: every filter, searched client-side (a few hundred rows at most).
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-filters-list-view',

    events: {
      'click .filter': 'onSelect'
    },

    initialize: function () {
      this.filters = [];
      this.query = '';
      this.selectedId = null;
    },

    setFilters: function (filters) {
      this.filters = filters || [];
      this.render();
    },

    setQuery: function (query) {
      this.query = (query || '').toLowerCase();
      this.render();
    },

    setSelected: function (id) {
      this.selectedId = id;
      this.$('.filter').removeClass('selected');
      this.$('.filter[data-id="' + id + '"]').addClass('selected');
    },

    serializeData: function () {
      var query = this.query;

      var filters = _.map(this.filters, function (f) {
        return {
          id: f.id,
          name: FiltersApi.name(f.names) || '(' + f.id + ')',
          code: f.code,
          webshop: f.webshop,
          valueCount: f.valueCount,
          productCount: f.productCount,
          search: (f.id + ' ' + f.code + ' ' + _.values(f.names).join(' ')).toLowerCase()
        };
      });

      if (query)
        filters = _.filter(filters, function (f) { return f.search.indexOf(query) !== -1; });

      return {
        filters: _.sortBy(filters, function (f) { return f.name.toLowerCase(); }),
        selectedId: this.selectedId
      };
    },

    onSelect: function (e) {
      var id = parseInt($(e.currentTarget).data('id'), 10);
      this.setSelected(id);
      this.trigger('select', id);
    }
  });
});

